
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/propiedades/alquilar",
      function () {
        return require("private-next-pages/propiedades/alquilar/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/propiedades/alquilar"])
      });
    }
  